import { configureStore } from '@reduxjs/toolkit';
import ecomerce, { syncCartFromStorage } from './features/ecommerceSlide';
import user from './features/userSlide';

export const store = configureStore({
    reducer: {
        user,
        ecomerce,
    },
    devTools: true,
});

if (typeof window !== 'undefined') {
    window.addEventListener('storage', (e) => {
        if (e.key === 'cartItems' && e.newValue !== null) {
            try {
                const updatedCart = JSON.parse(e.newValue);
                store.dispatch(syncCartFromStorage(updatedCart));
            } catch (err) {
                if (process.env.NODE_ENV === 'development') {
                    console.error('Cart sync error:', err);
                }
            }
        }
    });
}